import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'components/Button';
import { TbIllustration } from 'components/Figma';

export function MissingAsrMetricsCard({
  marketplacesWithoutOnline,
  onClickDeselectUnavailable,
  disabled = false,
}: {
  marketplacesWithoutOnline: string[];
  onClickDeselectUnavailable: () => void;
  disabled?: boolean;
}) {
  const intl = useIntl();

  return (
    <div className="flex flex-col h-full gap-4 p-6 bg-surface-grey whitespace-pre-line row-span-4 border-1 border-[#E6E6E6]">
      <div className="flex flex-row items-center w-full">
        <TbIllustration name="EmptyState" alt="No Online Data" className="w-16" />
        <h4 className="text-base font-semibold text-text-primary ml-3">
          <FormattedMessage id="articleVisibility.stepFour.error.title" />
        </h4>
      </div>

      <div>
        <p className="text-sm">
          <FormattedMessage
            id="articleVisibility.stepFour.error.description"
            values={{
              notOnline: intl.formatList(marketplacesWithoutOnline),
            }}
          />
        </p>
      </div>

      <div className="flex justify-center">
        <Button
          priority="secondary"
          data-testid="deselect-marketplaces"
          disabled={disabled}
          onClick={onClickDeselectUnavailable}
          className="transform-none"
        >
          <FormattedMessage id="articleVisibility.button.deselect_listed_marketplaces" />
        </Button>
      </div>
    </div>
  );
}
